import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { collection, query, where, getDocs, limit } from 'firebase/firestore';
import { db } from '../firebase';

const BannerContainer = styled.div`
  position: relative;
  width: 100%;
  margin-bottom: 1rem;
  overflow: hidden;
`;

const BannerImage = styled.img`
  width: 100%;
  height: auto;
  display: block;
`;

const DismissButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-size: 20px;
  line-height: 1;
  padding: 0;
  
  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
  }
`;

const MarketplaceBanner = () => {
  const [banner, setBanner] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const fetchActiveBanner = async () => {
      try {
        const bannerQuery = query(
          collection(db, 'banners'),
          where('isActive', '==', true),
          limit(1)
        );

        const bannerDocs = await getDocs(bannerQuery);
        if (!bannerDocs.empty) {
          const bannerData = bannerDocs.docs[0].data();
          setBanner(bannerData);
        }
      } catch (error) {
        console.error('Error fetching banner:', error);
      }
    };

    fetchActiveBanner();
  }, []);

  if (!banner || dismissed) return null;

  return (
    <BannerContainer>
      <BannerImage src={banner.imageUrl} alt="Marketplace Banner" />
      <DismissButton onClick={() => setDismissed(true)}>
        ×
      </DismissButton>
    </BannerContainer>
  );
};

export default MarketplaceBanner; 